import GlobeImage from '../../assets/icons/globe.png';
import TimeClockImage from '../../assets/icons/time_clock.png';
import { useNavigate } from 'react-router';
import { useContext } from 'react';
import useSWR from 'swr';
import { AuthContext } from '../../context/AuthContext';
import { getGetTodayGameUserCountUrl } from '../../api/generated/time-nyang/main/main.ts';

function PlaygroundMiniGamesCardRow() {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const { data: todayUsers } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}${getGetTodayGameUserCountUrl()}`, accessToken],
    fetchWithToken,
  );

  const formatCount = (value, fallback) =>
    Number.isFinite(value) ? Number(value).toLocaleString('ko-KR') : fallback.toLocaleString('ko-KR');
  const punchUserCountText = formatCount(todayUsers?.gamePunchUserCount, 0);
  const timeNyangUserCountText = formatCount(todayUsers?.timeNyangUserCount, 0);

  return (
    <div className="">
      <div className="flex w-full items-start gap-2.5">
        <article
          className="flex flex-1 cursor-pointer flex-col items-start gap-1.5"
          onClick={() => navigate('/punch')}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              navigate('/punch');
            }
          }}
          aria-label="냥냥펀치 이동"
        >
          <div className="relative flex h-36 w-full flex-col items-start gap-1.5 overflow-hidden rounded-tl-3xl rounded-tr-3xl rounded-br-3xl bg-gradient-to-b from-white to-violet-200 p-4 shadow-[0_4px_8px_rgba(0,0,0,0.15)]">
            <div className="relative z-10 w-full">
              <p className="pb-px text-right text-[10px] font-extrabold uppercase tracking-wide text-gray05">
                ⚡ 즉시 보상
              </p>
              <h3 className="text-xl font-black leading-5 text-primary-purple-01">냥냥펀치</h3>
            </div>
            <p className="relative z-10 text-xs font-semibold leading-4 text-gray04">
              펀치 한방에
              <br />
              대폭발하면
            </p>
            <div className="absolute bottom-4 left-4 z-10 flex items-end gap-0.5">
              <span className="mb-0.5 text-[10px] font-bold leading-3 text-gray05">한번에</span>
              <span className="text-2xl font-black leading-6 text-gray05">150</span>
              <span className="mb-0.5 text-xs font-bold leading-3 text-gray05">P</span>
            </div>
            <img
              src={GlobeImage}
              alt="냥냥펀치 아이콘"
              className="absolute bottom-2 right-1 z-10 h-16 w-16 object-contain"
            />
          </div>
          <div className="flex items-center justify-center rounded-[5px] bg-gradient-to-r from-primary-purple-01 to-violet-500 px-4 py-[5px]">
            <p className="text-xs font-extrabold uppercase tracking-wide text-white">
              {punchUserCountText}명 도전 중
            </p>
          </div>
        </article>

        <article
          className="flex flex-1 cursor-pointer flex-col items-start gap-1.5"
          onClick={() => navigate('/time-nyang')}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              navigate('/time-nyang');
            }
          }}
          aria-label="타임냥 이동"
        >
          <div className="relative flex h-36 w-full flex-col items-start gap-1.5 overflow-hidden rounded-tl-3xl rounded-tr-3xl rounded-br-3xl bg-gradient-to-b from-white to-sky-200 p-4 shadow-[0_8px_16px_rgba(0,0,0,0.15)]">
            <div className="relative z-10 w-full">
              <p className="pb-px text-right text-[10px] font-extrabold uppercase tracking-wide text-gray05">
                🎯 타이밍 승부
              </p>
              <h3 className="text-xl font-black leading-5 text-primary-blue">타임냥</h3>
            </div>
            <p className="relative z-10 text-xs font-semibold leading-4 text-gray04">
              3.23초를
              <br />
              정확히 맞추면
            </p>
            <div className="absolute bottom-4 left-4 z-10 flex items-end gap-0.5">
              <span className="mb-0.5 text-[10px] font-bold leading-3 text-gray05">한번에</span>
              <span className="text-2xl font-black leading-6 text-gray05">400</span>
              <span className="mb-0.5 text-xs font-bold leading-3 text-gray05">P</span>
            </div>
            <img
              src={TimeClockImage}
              alt="타임냥 아이콘"
              className="absolute bottom-2 right-1 z-10 h-16 w-16 object-contain"
            />
          </div>
          <div className="flex items-center justify-center rounded-[5px] bg-gradient-to-r from-primary-blue to-sky-500 px-4 py-[5px]">
            <p className="text-xs font-extrabold uppercase tracking-wide text-white">
              {timeNyangUserCountText}명 도전 중
            </p>
          </div>
        </article>
      </div>
    </div>
  );
}

export default PlaygroundMiniGamesCardRow;
